import * as React from "react";
import {
  useDispatch,
  useMappedState
} from "redux-react-hook";

import { setCurrentList } from "src/core/lists/store/lists.actions";
import { ICurrentList } from "src/core/lists/store/lists.reducer";
import { setCurrentOrder } from "src/core/orders/store/orders.actions";
import { IStore } from "src/core/shared/store/index";

const useSetCurrentList = () => {
  const dispatch = useDispatch();
  const currentOrder = useMappedState(({ orders }: IStore) => orders.currentOrder);
  const hasCurrentOrder = React.useMemo(() => !!currentOrder?.data, [ currentOrder.data ]);

  return React.useCallback(
    (newCurrentList: ICurrentList | null) => {
      if (hasCurrentOrder && newCurrentList) {
        dispatch(setCurrentOrder(null));
      }

      dispatch(setCurrentList(newCurrentList || null));
    },
    [ dispatch, hasCurrentOrder ]
  );
};

export default useSetCurrentList;
